import { createContext, useContext } from 'react';

const NOOP = () => {};

export const TransferRevealSuppressionContext = createContext({
  setSquadRevealOpen: NOOP,
});

export function useTransferRevealSuppression() {
  return useContext(TransferRevealSuppressionContext);
}
